document.addEventListener('shopify:section:load', function () {
  gsapAnimations();
});

document.addEventListener('DOMContentLoaded', function () {
  gsapAnimations();
});

function gsapAnimations() {
  gsap.registerPlugin(ScrollTrigger);

  // Select all the .kg-wrapper-container sections
  const sections = document.querySelectorAll('.kg-wrapper-container');

  sections.forEach((section, index) => {
    // Create a GSAP timeline for each section independently
    const imgH3p = gsap.timeline({
      scrollTrigger: {
        trigger: section, // Use the specific section as the trigger
        start: "top 80%", // Start animation when the top of the wrapper hits 80% of the viewport
        end: "bottom 20%", // End animation when the bottom of the wrapper reaches 20% of the viewport
        toggleActions: "play none none reverse"
      }
    });

    // Image animation - slide in from right to left
    imgH3p.from(section.querySelector(".kg-slide-image"), {
      x: "100vw", // Start off-screen to the right
      opacity: 0, // Start with opacity 0
      duration: 1,
      ease: "power2.out"
    })
      // h3 animation - slide in after the image
      .from(section.querySelector(".kg-slide-h3"), {
        x: "100vw",
        opacity: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=0.7") // Overlapping by 0.7 seconds to create a smooth sequence

      // p animation - slide in after the h3
      .from(section.querySelector(".kg-slide-p"), {
        x: "100vw",
        opacity: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=0.7") // Overlapping by 0.7 seconds

      // Button animation - slide in after the p tag
      .from(section.querySelector(".kg-slide-a"), {
        x: "100vw",
        opacity: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=0.7"); // Overlapping by 0.7 seconds
  });
}
